<template>
	<Popup :open="open" mode="prompt" @closePopup="declinePrompt">
        <h2>{{popupPrompt.title}}</h2>
		<p>{{popupPrompt.prompt}}</p>
		<div class="row">
			<div class="col">
				<button @click="acceptPrompt">{{popupPrompt.confirmText}}</button>
			</div>
			<div v-if="typeof popupPrompt.showCancelButton === 'undefined' || popupPrompt.showCancelButton === true" class="col">
				<button @click="declinePrompt">{{popupPrompt.denyText}}</button>
			</div>
		</div>
	</Popup>
</template>

<script>
	import Popup from "@/components/popup/Popup";
	import {mapState} from "vuex";
	export default {
		data(){
			return{
				open: false
            }
        },
		mounted(){
			this.open = true
        },
		components: {Popup},
		computed:{
			...mapState('vorbasse', {
				popupPrompt: 'popupPrompt',
			}),
		},
		methods:{
			acceptPrompt(){
				this.popupPrompt.callback(true);
			},
			declinePrompt(){
				this.popupPrompt.callback(false);
			}
		}
	};
</script>

<style scoped>

</style>
